var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('section',[_vm._t("header"),_vm._v(" "),_c('section',{staticClass:"pins"},_vm._l((_vm.getPins),function(patient){return _c('pins-item-patient',{key:patient.id,attrs:{"patient":patient}})}),1)],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20276853","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/pins/Pins.vue
// module id = null
// module chunks = 